export const restaurant = {
  name: 'Ember & Vine',
  shortName: 'E&V',
  descriptor: 'Contemporary Indian dining',
  city: 'Denver, Colorado',
  hero: {
    eyebrow: 'Contemporary Indian dining · Denver',
    title: 'An elevated journey through India',
    supporting:
      'Modern Indian cuisine, refined through fire, spice, tradition, and imagination.',
    sensoryLine: 'Regional memory. Seasonal ingredients. A table set for discovery.',
  },
  story: {
    title: 'The warmth of a shared table, composed for now.',
    lead:
      'Ember & Vine brings regional Indian flavors into a contemporary dining room—layering live-fire technique, seasonal produce, and polished hospitality without losing the soul of the dish.',
    detail:
      'The menu moves from the char of the tandoor to slow-built sauces and fragrant rice, with each plate designed to be passed, discussed, and remembered.',
  },
  dishes: [
    {
      number: '01',
      name: 'Ember tandoori chicken',
      description:
        'Charred over live fire, finished with smoked pepper, lemon, and a restrained fenugreek glaze.',
      image: '/images/tandoori.webp',
      alt: 'Tandoori chicken presented with lemon and herbs on a dark ceramic platter',
    },
    {
      number: '02',
      name: 'Saffron dum biryani',
      description:
        'Aromatic basmati, caramelized onion, herbs, and saffron sealed together for a fragrant tableside reveal.',
      image: '/images/biryani.webp',
      alt: 'Saffron biryani in a brass serving bowl with herbs and crisp onion',
    },
    {
      number: '03',
      name: 'Smoked tomato makhani',
      description:
        'Velvet tomato, cultured butter, and warm spice balanced with smoke and a bright ginger finish.',
      image: '/images/curry.webp',
      alt: 'Glossy tomato curry in a cream ceramic bowl with ginger garnish',
    },
  ],
  experience: [
    {
      title: 'The room',
      text: 'Dark walnut, brushed brass, linen, and ember light create intimacy without formality.',
    },
    {
      title: 'At the bar',
      text: 'Spice-led cocktails, considered zero-proof pairings, and a cellar shaped for the menu.',
    },
    {
      title: 'Around your table',
      text: 'Attentive, unhurried service for dinner, celebrations, and private occasions.',
    },
  ],
  chef: {
    name: '',
    role: 'Executive chef',
    title: 'Curiosity in the kitchen. Memory at the table.',
    philosophy:
      'Our culinary philosophy begins with regional technique: building depth slowly, respecting the character of each spice, and letting the tandoor leave its mark. Contemporary presentation brings clarity, never distance, to food made for sharing.',
  },
  contact: {
    addressLines: ['1234 Walnut Street', 'Denver, CO 80205'],
    phoneDisplay: '(303) 555-0142',
    phoneHref: '+13035550142',
    email: 'table@emberandvine.example',
  },
  hours: [
    ['Tuesday–Thursday', '5:00–10:00 pm'],
    ['Friday–Saturday', '5:00–11:00 pm'],
    ['Sunday', '5:00–9:00 pm'],
    ['Monday', 'Closed'],
  ],
  links: {
    reservation: '#reservations',
    menu: '#menu',
    instagram: '#',
    privateDining: 'mailto:events@emberandvine.example',
    accessibility: '#accessibility',
    privacy: '#privacy',
  },
} as const

export type RestaurantConfig = typeof restaurant

